import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ReviewService } from 'src/app/services/review.service';
import { LibService } from 'src/app/services/libService';
import { SubjectService } from 'src/app/services/subject.service';
import { OrderService } from 'src/app/services/order.service';
import { AuthService } from 'src/app/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { AddUsersModal } from './notification-system-modals/add-users-modal/add-users-modal.component';
import { UserDataService } from '../services/users.service';

@Component({
  selector: 'app-notification-system',
  templateUrl: './notification-system.component.html',
  styleUrls: ['./notification-system.component.scss'],
})
export class NotificationSystemComponent implements OnInit {
  @Input() users: any = [];
  @Input() global: boolean = false;
  usersSelected: any = [];
  usersSelectedList: any = [];
  form: FormGroup;
  internalUsers: any = []
  externalUsers: any = []

  constructor(
    private toastr: ToastrService,
    public translate: TranslateService,
    private fb: FormBuilder,
    private reviewService: ReviewService,
    private libService: LibService,
    public subjectService: SubjectService,
    public orderService: OrderService,
    public authService: AuthService,
    private dialog: MatDialog,
    private userDataService: UserDataService,
  ) { }

  notificationChannels: any = [
    { code: 'notification_channels_email', label: 'Email', disabled: false },
    { code: 'notification_channels_push', label: 'Push', disabled: false },
    { code: 'notification_channels_sms', label: 'SMS', disabled: true },
  ];

  ngOnInit(): void {
    // Creazione Form
    this.form = this.fb.group({
      title: [null, [Validators.required]],
      body: [null, [Validators.required]],
      notificationChannels: [null],
    });

    if (this.global) this.initUsers()
    if (this.global) this.initExtenalUsers()
  }

  initUsers(): void {
    let tmpUsers: any = []
    this.userDataService.index().subscribe((res: any) => {
      console.log(res)
      res.forEach((user: any) => {
        tmpUsers.push({
          UserId: user.id,
          user: user,
          company: {},
          type: "internal"
        })
      });

      this.internalUsers = tmpUsers

    }, err => {
      console.log(err)
    });

  }

  initExtenalUsers(): void {
    let tmpUsers: any = []
    this.userDataService.indexExt().subscribe((res: any) => {
      console.log(res)
      res.forEach((user: any) => {
        tmpUsers.push({
          UserId: user.id,
          user: user,
          company: {},
          type: "external"
        })
      });

      this.externalUsers = tmpUsers

    }, err => {
      console.log(err)
    });

  }

  sendNotificationSettings() {
    //this.libService.lockPage('');
    let id = this.form?.get('id')?.value || null;

    let formValues = this.form?.getRawValue();
    if (formValues.insertSubjectType == 'alias') formValues.subject = null;

    if (id) {
      /*
      this.reviewService.update(this.item?.id?.toString(), formValues).subscribe((res: any) => {
        //console.log(res);
        this.toastr.success(this.translate.instant('LABEL.DATA_SUCCESS'), this.translate.instant('TOASTR.INFO'));
        this.closeModal.emit(true);
        this.libService.unlockPage();
      })
      */
    } else {
      /*
      this.reviewService.create(formValues).subscribe((res: any) => {
        //console.log(res);
        this.toastr.success(
          this.translate.instant('LABEL.DATA_SUCCESS'),
          this.translate.instant('TOASTR.INFO')
        );
        this.libService.unlockPage();
      });
      */
    }
  }

  openUserModal(type: string) {
    let data: any = {
      global: this.global
    };

    if (this.global) {
      if (type == 'internal') data.users = this.internalUsers
      if (type == 'external') data.users = this.externalUsers
    } else {
      data.users = this.users.filter(
        (registration: any) => registration.type == type
      );
    }


    const dialogRef = this.dialog.open(AddUsersModal, {
      width: '90%',
      data: data,
      scrollStrategy: new NoopScrollStrategy(),
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        result.forEach((user: any) => {
          let status = this.usersSelected.find(
            (u: any) => u.id === user.id && u.type == user.type
          );
          if (!status) this.usersSelected.push(user);
        });
      }
    });
  }

  removeUser(user: any) {
    console.log(user.id)
    console.log(user.type)
    this.usersSelected = this.usersSelected.filter(
      (u: any) => u.id !== user.id || u.type !== user.type
    );
  }

  getColor(user: any) {
    return user.type == 'internal' ? 'primary' : 'accent';
  }
}
